import type React from 'react'
import { Table } from '@/components/ui/table'
import { cn } from '@/lib/cn'
import { fmtMoney } from './format'
import type { TrialBalanceResponse } from '@/features/reporting/types'

interface Props {
  data: TrialBalanceResponse
  tableRef?: React.MutableRefObject<HTMLTableElement | null>
}

export function TrialBalanceReport({ data, tableRef }: Props) {
  return (
    <div className="overflow-x-auto rounded-md border">
      <Table className="w-full min-w-[640px] text-sm" ref={tableRef}>
        <thead className="bg-primary-gradient text-xs uppercase tracking-wide text-primary-foreground">
          <tr>
            <th className="px-3 py-2 text-left">Account Code</th>
            <th className="px-3 py-2 text-left">Account Name</th>
            <th className="px-3 py-2 text-left">Category</th>
            <th className="px-3 py-2 text-right">Debit</th>
            <th className="px-3 py-2 text-right">Credit</th>
          </tr>
        </thead>
        <tbody>
          {data.accounts.map((a) => (
            <tr key={a.accountCode} className="border-t">
              <td className="px-3 py-1.5">{a.accountCode}</td>
              <td className="px-3 py-1.5">{a.accountName}</td>
              <td className="px-3 py-1.5">{a.mainCategory}</td>
              <td className="px-3 py-1.5 text-right">{a.debit > 0 ? fmtMoney(a.debit) : ''}</td>
              <td className="px-3 py-1.5 text-right">{a.credit > 0 ? fmtMoney(a.credit) : ''}</td>
            </tr>
          ))}
          <tr className="border-t-2 bg-muted font-bold">
            <td colSpan={3} className="px-3 py-1.5">
              TOTALS
            </td>
            <td className="px-3 py-1.5 text-right">{fmtMoney(data.totalDebits)}</td>
            <td className="px-3 py-1.5 text-right">{fmtMoney(data.totalCredits)}</td>
          </tr>
          <tr>
            <td colSpan={5} className="px-3 py-1.5">
              <span
                className={cn(
                  'font-semibold',
                  data.isBalanced ? 'text-success' : 'text-destructive',
                )}
              >
                {data.isBalanced ? 'Trial Balance is balanced' : 'Trial Balance is NOT balanced'}
              </span>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}
